import { Textarea } from "@jewlr/storybook/form"
import PropTypes from "prop-types"
import React from "react"
import { Controller } from "react-hook-form"
import styled from "styled-components"

const GiftMessage = styled(Textarea).attrs((props) => ({
  border: `solid 1px ${props.theme.colors.grey[35]}`,
  ...props,
}))`
  height: 85px;
  margin-bottom: 0;
  ${({ theme }) => theme.mediaQueries.tablet`
    flex-basis: 100%;
  `};
`

const GiftCardDarkTextArea = ({ control, name, placeholder }) => {
  return (
    <Controller
      control={control}
      name={name}
      render={({ field, fieldState: { error } }) => (
        <GiftMessage {...field} error={error} placeholder={placeholder} />
      )}
    />
  )
}

GiftCardDarkTextArea.propTypes = {
  control: PropTypes.object,
  name: PropTypes.string.isRequired,
  placeholder: PropTypes.string,
  type: PropTypes.string,
}

export default GiftCardDarkTextArea
